import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './TradingTokenImageUploader.scss';
import { assets } from '../../../../assets/assets';
import { Uploader } from '../../../../CMSApp/components/Uploader';

interface Props {
  preview?: string;
  onFileChange: (file?: File) => void;
  uploadState: number;
}

export const TradingTokenImageUploader = ({
  onFileChange,
  uploadState,
  preview,
}: Props) => {
  const uploader = useRef<HTMLInputElement>(null);

  const [file, setFile] = useState<File>();

  useEffect(() => {
    setFile(undefined);
  }, [uploadState]);

  const onFileUploaded = useCallback(async (f: File) => {
    setFile(f);
    onFileChange(f);
  }, []);

  const openFileUploader = useCallback(() => {
    if (!uploader?.current) {
      return;
    }
    onClearImage();
    uploader.current.click();
  }, [uploader.current]);

  const onClearImage = useCallback(() => {
    setFile(undefined);
    onFileChange(undefined);
  }, []);

  const imageUrl = useMemo(() => {
    if (preview) {
      return preview;
    }
    if (file) {
      return URL.createObjectURL(file);
    }
  }, [file, preview]);

  return (
    <div className="container" onClick={openFileUploader}>
      <div className="img-container">
        <div className="img-box">
          <div className="btn btn-add">
            {imageUrl ? (
              <img src={imageUrl} style={{ width: '100%', height: '100%' }} />
            ) : (
              <img
                src={assets.icon_camera}
                style={{ width: '40px', height: '40px' }}
              />
            )}
          </div>
        </div>

        {!file && (
          <div className="warning">
            <div className="title">Token image</div>
            <div className="required">*</div>
          </div>
        )}
      </div>

      <Uploader
        ref={uploader}
        id={'image-uploader'}
        onFileUploaded={onFileUploaded}
        accept="image/*"
      />
    </div>
  );
};
